import { init } from './modules/_char_counter.js';

window.auguste = window.auguste || {};
window.auguste.CharCounter = { init };
